<template>
  <div class="col-xl-12">
    <div class="appointment">
      <div class="card">
        <div class="card-header card-no-border">
          <div class="header-top">
            <h5 class="m-0">DISTRIBUTOR STOCK</h5>

            <div>
              <span v-if="loading1" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
              <span v-else class="current-month">{{ currentYearAndMonth.toUpperCase() }}</span>
            </div>
          </div> <br>

          <div>
            <select v-model="selectedDistributor" class="form-select me-2">
              <option value="">All Distributors</option>
              <option
                  v-for="distributor in distributors"
                  :key="distributor.profile_id"
                  :value="distributor.profile_id">
                {{ distributor.name }}
              </option>
            </select>
          </div>
        </div>
        <div class="card-body" :class="loading2 ? 'loading-center' : 'pt-0'">
          <div class="appointment-table table-responsive">
            <!-- Loading spinner -->
            <div v-if="loading2" class="spinner-container">
              <div class="spinner"></div>
            </div>

            <!-- Error Message -->
            <div v-if="error" class="error-container">
              <img src="../../../../assets/vectors/data_not_found.png" alt="Error" class="error-image" />
              <p class="error-message">{{ error }}</p>
            </div>

            <!-- Table Data -->
            <table v-if="!loading2 && !error" class="table table-bordernone">
              <tbody>
              <tr v-for="(item) in distributorStocks" :key="item.SAPCode">
                <td>
                  <img
  v-if="item.imageUrl"
  :src="item.imageUrl"
  loading="lazy"
  class="item-image"
/>
                  <i v-else class="fa-solid fa-image item-icon"></i>
                </td>
                <td class="img-content-box">
                  <h6 class="f-14 mb-0">{{ item.itemName.toUpperCase() }}</h6>
                  <p class="m-0 text-black">SAP Code : {{ item.sapCode }}</p>
                </td>
                <td class="text-end">
                  <span class="status-chip">
                  ({{ item.qtymt ?? 0 }} MT)
                  </span>
                  <br />
                </td>
              </tr>
              </tbody>
            </table>
            <br>
            <a
                v-if="!loading1 && !loading2 && !error"
                class="see-more"
                :href="$router.resolve({ path: '/distributor-stock-report' }).href"
                target="_blank"
            >
              See More
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { fetchDistributors, fetchDistributorStocks } from "@/services/dataService";

export default {
  data() {
    return {
      token: localStorage.getItem("token_set"),
      profileId: localStorage.getItem("profile_id"),
      selectedDistributor: "",
      distributorStocks: [],
      loading1: false,
      loading2: false,
      error: null,
      currentYearAndMonth: this.getCurrentYearAndMonth(),
    };
  },

  mounted() {
    this.fetchDistributorsList();
    this.fetchDistributorStock("");
  },

  watch: {
    selectedDistributor(newVal) {
      if (newVal === "") {
        this.fetchDistributorStock("");
      } else {
        this.fetchDistributorStock(newVal);
      }
    },
  },

  methods: {
    // decodeBase64Image(base64Str) {
    //   return `data:image/png;base64,${base64Str}`;
    // },

    getCurrentYearAndMonth() {
      const now = new Date();
      const year = now.getFullYear();
      const month = now.toLocaleString("default", { month: "long" });
      return `${year} ${month}`;
    },

    async fetchDistributorsList() {
      try {
        this.loading1 = true;
        this.distributors = [];
        const response = await fetchDistributors(this.profileId, this.token);
        this.distributors = response.data.data;
      } catch (e) {
        console.log("error", e);
      } finally {
        this.loading1 = false;
      }
    },

    async fetchDistributorStock(distributorId = "") {
      try {
        this.loading2 = true;
        this.distributorStocks = [];
        this.error = null;

        const payload = { distributor_id: distributorId };

        const response = await fetchDistributorStocks(payload, this.token);

        if (response.data.success === true) {
          this.distributorStocks = response.data.data
            .slice(0, 5)
            .map((distributorStock) => {
              const itemName = distributorStock.item_name;
              const quantity = distributorStock.open_stock;

              // Extract weight (e.g. "12.5" from "12.5KG FILLED")
              const weightMatch = itemName.match(/([\d.]+)\s*KG/i);
              let qtymt = null;

              if (weightMatch && quantity > 0) {
                const weight = parseFloat(weightMatch[1]);
                qtymt = ((quantity * weight) / 1000).toFixed(3); // Convert to MT, 3 decimals
              }

              return {
                // itemImage: distributorStock.image || null,
                itemName: itemName,
                sapCode: distributorStock.sap_code || "N/A",
                quantity: quantity,
                qtymt: qtymt,
              };
            });
        } else {
          this.error = response.data.message;
        }
      } catch (e) {
        this.error = "Something went wrong";
      } finally {
        this.loading2 = false;
      }
    },
  },
};
</script>


<style scoped>
.current-month {
  color: #5A6166;
}

/* Spinner container styling */
.spinner-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 150px; /* Set a height to vertically center the spinner */
}

/* Spinner styling */
.spinner {
  border: 4px solid rgba(0, 0, 0, 0.1); /* Light border */
  border-top: 4px solid #0b43c6; /* Spinner color (green theme) */
  border-radius: 50%;
  width: 36px;
  height: 36px;
  animation: spin 1s linear infinite;
}

/* Animation for the spinner */
@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

/* Centering the spinner when loading */
.loading-center {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 300px; /* Optional fixed height */
}

/* Item image styling */
.item-image {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  object-fit: cover;
}

/* Font Awesome icon styling */
.item-icon {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  color: #5A6166; /* Grey color for the icon */
  background: #f5f5f5; /* Light grey background */
  border-radius: 50%;
}

/* Status chip styling */
.status-chip {
  display: inline-block;
  padding: 0.25rem 0.75rem;
  border-radius: 5px;
  font-size: 14px;
  font-weight: lighter; /* Light font weight for chip text */
  text-transform: capitalize;
  background-color: #000;
  color: #fff;
}

.see-more {
  color: #0b43c6;
  font-weight: bold;
}

.see-more:hover {
  cursor: pointer;
  font-weight: bold;
  color: #5A6166;
}

/* Center content inside the table row */
.error-container {
  text-align: center;
}

/* Results not found image */
.error-image {
  max-width: 200px;
  display: block;
  margin: 0 auto;
}

/* Results not found message */
.error-message {
  font-size: 15px;
  font-weight: bold;
  color: #0b43c6;
  padding-top: 10px;
}
</style>
